<template>
<div>
    <Breadcrumbs main="Admin" title="Marathon" />
    
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
  
                    
                    <div class="card-body">
                        <b-row>
                            <b-col xl="6">
                                <div class="d-flex flex-column flex-xl-row " style="gap: 10px;">
                                    <b-input-group class="datatable-btn">
                                        <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
                                        <b-input-group-append>
                                            <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                                        </b-input-group-append>
                                    </b-input-group>

                                </div>

                            </b-col>

                            <b-col xl="6">
                                <b-form-group label-cols="2" label="Per page" class="mb-0 datatable-select">
                                    <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                                </b-form-group>
                            </b-col>
                        </b-row>
                       

                        <div v-if="!loading && !error">
                            <div class="table-responsive datatable-vue">
                                <b-table show-empty stacked="md" :items="items" :fields="tablefields" :filter="filter" :current-page="currentPage" :per-page="perPage" @filtered="onFiltered">
                                    <template #cell(index)="data">
                                        {{ (currentPage - 1) * perPage + data.index + 1 }}
                                    </template>
                                    
                                    <template #cell(name)="data">
                                      <div v-if="data.item.name">
                                         <p> {{ data.item.name }}</p>
                                      </div>
                                    </template>
                                   
                                    <template #cell(email)="data">
                                      <div v-if="data.item.email">
                                         <p> {{ data.item.email }}</p>
                                      </div>
                                    </template>
                                
                                    <template #cell(action)="data">
                                            <feather type="eye" size="22px" style="color: #0B81FF; cursor: pointer;" v-b-tooltip.hover v-b-modal.modal-center-details  @click="detailContent(data.item)" title="Details"></feather>
                                    </template>
                                
                                    
                                </b-table>
                            </div>
                        </div>

                        <div v-else>
                            <loader />
                        </div>

                        <b-col md="6" class="my-1 p-0">
                            <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" class="my-0"></b-pagination>
                        </b-col>

                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Container-fluid Ends-->

    <!-- Marathon Modal -->
    <b-modal id="modal-center-details" centered hide-header size="lg">
        <div class="mt-4 mb-4 font-weight-bold" style="font-size: large;">Marathon Details</div>

        

        <div class="row mb-2">
            <div class="col-sm-4 d-flex flex-column">
                <span class="font-weight-bold">Name</span>
                <span>{{ contents.name ? contents.name : '-' }} </span>
            </div>
            <div class="col-sm-4 d-flex flex-column">
                <span class="font-weight-bold">Email</span>
                <span>{{ contents.email ? contents.email : '-' }}</span>
            </div>
            <div class="col-sm-4 d-flex flex-column">
                <span class="font-weight-bold">Phone</span>
                <span>{{ contents.phone ? contents.phone : '-' }}</span>
            </div>
        </div>

        <div class="row mb-2">
            <div class="col-sm-4 d-flex flex-column">
                <span class="font-weight-bold">Gender</span>
                <span class="text-capitalize">{{ contents.gender ? contents.gender : '-' }}</span>
            </div>
             <div class="col-sm-4 d-flex flex-column">
                <span class="font-weight-bold">Date of Birth</span>
                <span class="text-capitalize">{{ contents.date_of_birth ? contents.date_of_birth : '-' }}</span>
            </div>
        </div>
        <div class="row mb-2">
            <div class="col-sm-4 d-flex flex-column">
                <span class="font-weight-bold">State</span>
                <span>{{ contents.state ? contents.state.name : '-' }} </span>
            </div>
            <div class="col-sm-4 d-flex flex-column">
                <span class="font-weight-bold">City</span>
                <span>{{ contents.city ? contents.city.name : '-' }}</span>
            </div>
            <div class="col-sm-4 d-flex flex-column">
                <span class="font-weight-bold">ZIP Code</span>
                <span>{{ contents.zip_code ? contents.zip_code : '-' }}</span>
            </div>
        </div>

        <div class="row mb-2">
            <div class="col-sm-4 d-flex flex-column">
                <span class="font-weight-bold">Discomfort</span>
                <span class="text-capitalize">{{ contents.discomfort ? contents.discomfort : '-' }} </span>
            </div>
            <div class="col-sm-4 d-flex flex-column">
                <span class="font-weight-bold">Joining</span>
                <span class="text-capitalize">{{ contents.joining ? contents.joining : '-' }}</span>
            </div>
            <div class="col-sm-4 d-flex flex-column">
                <span class="font-weight-bold">Skill Level</span>
                <span>{{ contents.skill_level ? contents.skill_level : '-' }}/5</span>
            </div>
        </div>
        
        <div class="row mb-2" v-if="contents.text">
            <div class="col-sm-12 d-flex flex-column">
                <span class="font-weight-bold">Description</span>
                <span class="text-capitalize">{{ contents.text ? contents.text : '-' }}</span>
            </div>
           
        </div>
        
        <div class="mt-4 mb-2 font-weight-bold" style="font-size: normal;">Emergency Contact</div>
        <div class="row mb-2">
            <div class="col-sm-4 d-flex flex-column">
                <span class="font-weight-bold">Name</span>
                <span>{{ contents.emergency_name ? contents.emergency_name : '-' }} </span>
            </div>
            <div class="col-sm-4 d-flex flex-column">
                <span class="font-weight-bold">Email</span>
                <span>{{ contents.emergency_email ? contents.emergency_email : '-' }}</span>
            </div>
            <div class="col-sm-4 d-flex flex-column">
                <span class="font-weight-bold">Phone</span>
                <span>{{ contents.emergency_phone ? contents.emergency_phone : '-' }}</span>
            </div>
        </div>
        <div class="row mb-2">
            <div class="col-sm-12 d-flex flex-column">
                <span class="font-weight-bold">Address</span>
                <span>{{ contents.emergency_address1 ? contents.emergency_address1 : '-' }} </span>
                <span>{{ contents.emergency_address2 ? contents.emergency_address2 : '-' }} </span>
            </div>
        </div>

        
        
    </b-modal>

</div>
</template>

<script>
import {
    mapState
} from 'vuex';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';
import js from '../../../auth/js';
import {
    myHost
} from '../../../_helpers/host'
import loader from '../loader/loader.vue'
export default {
    components: {
        loader,
    },
    data() {
        return {
            host: myHost.host,
            tablefields: [
                {
                    key: 'index',
                    label: '#'
                },
            
                {
                    key: 'name',
                    label: 'Name',
                    sortable: true
                },
                
                {
                    key: 'email',
                    label: 'Email',
                    sortable: true
                },
             
                {
                    key: 'action',
                    label: 'Action',
                    sortable: false
                }
            ],

            filter: null,
            delete_value: null,

            totalRows: 1,
            currentPage: 1,
            perPage: 10,
            pageOptions: [5, 10, 15],
            contents:{
                id:'',
                name:'',
                email:'',
                phone:'',
                gender:'',
                date_of_birth:'',
                emergency_name:'',
                emergency_email:'',
                emergency_phone:'',
                emergency_address1:'',
                emergency_address2:'',
                state:null,
                city:null,
                zip_code:'',
                text:'',
                discomfort:'',
                joining:'',
                skill_level:'',
            }
        };
    },

    computed: {
        ...mapState({
            items: state => state.marathon.marathon,
            loading: state => state.marathon.marathonLoading,
            error: state => state.marathon.marathonError,
        }),

        sortOptions() {
            return this.tablefields
                .filter(f => f.sortable)
                .map(f => {
                    return {
                        text: f.label,
                        value: f.key
                    };
                });
        }
    },

    mounted() {

        this.$store.dispatch("marathon/fetchMarathon").then(() => {
            this.totalRows = this.items.length;

        });

    },

    watch: {

    },

    methods: {
        detailContent(data){
            this.contents.id = data.id ? data.id : ''
            this.contents.name = data.name ? data.name : ''
            this.contents.email = data.email ? data.email : ''
            this.contents.phone = data.phone ? data.phone : ''
            this.contents.gender = data.gender ? data.gender : ''
            this.contents.date_of_birth = data.date_of_birth ? data.date_of_birth : ''
            this.contents.emergency_name = data.emergency_name ? data.emergency_name : ''
            this.contents.emergency_email = data.emergency_email ? data.emergency_email : ''
            this.contents.emergency_phone = data.emergency_phone ? data.emergency_phone : ''
            this.contents.emergency_address1 = data.emergency_address1 ? data.emergency_address1 : ''
            this.contents.emergency_address2 = data.emergency_address2 ? data.emergency_address2 : ''
            this.contents.state = data.state ? data.state : null
            this.contents.city = data.city ? data.city : null
            this.contents.zip_code = data.zip_code ? data.zip_code : ''
            this.contents.text = data.text ? data.text : ''
            this.contents.discomfort = data.discomfort ? data.discomfort : ''
            this.contents.joining = data.joining ? data.joining : ''
            this.contents.skill_level = data.skill_level ? data.skill_level : ''
          
        },
        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },

    }
};
</script>

<style scoped>
.header-mobile {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

@media screen and (max-width: 460px) {
    .header-mobile {
        display: flex;
        flex-direction: column;
        gap: 16px;
        align-items: start;
    }
}
</style>
